<div
  class="flex flex-col flex-wrap h-full print:h-auto print:overflow-visible w-full"
>
  <div
    class="flex items-start w-full px-3 py-2 bg-white shadow-sm z-5 gap-2"
    [ngClass]="toolbarClass"
  >
    @if (showBackButton) {
      <p-button
        size="large"
        variant="text"
        icon="pi pi-arrow-right"
        (onClick)="goBack()"
      >
      </p-button>
    }

    <div class="flex flex-wrap items-center w-full h-full gap-2">
      @if (title) {
        <h5 class="flex flex-auto font-bold items-center m-0!">
          {{ title }}
        </h5>
      }
      @if (buttonsTemplate) {
        <div
          class="flex flex-wrap justify-end gap-2 shrink-0 max-w-full ms-auto"
        >
          <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
        </div>
      }
    </div>
  </div>
  <div
    class="flex-1 h-0 w-full px-6 overflow-y-auto print:h-auto print:overflow-visible"
    [ngClass]="contentClass"
    (scroll)="onContentScroll($event)"
  >
    <div class="mt-4!">
      <ng-container *ngTemplateOutlet="contentTemplate || null"></ng-container>
    </div>
  </div>
</div>
